import styled from 'styled-components';

export const Container = styled.div`
  border-radius: 100px;
  width: 19px;
  height: 19px;
  overflow: hidden;

  & img {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }
`;
